import React from "react";
import "./FailModal.scss";
import IcFail from "./IcFail.svg";

const FailModal = ({
  onRetry,
  onCancel,
  title,
  description,
  show,
  cancelText = "Cancel",
  retryText = "Retry",
  hideIcon = false,
  customFooter = null,
  reverse = false,
}) => {
  if (!show) {
    return null;
  }

  return (
    <div className="overlay ads-fail-modal-wrapper" onClick={onCancel}>
      <div className="modal-box">
        <p className="modal-title">{title}</p>
        <section className="modal-desc">
          {!hideIcon && <img src={IcFail} alt="ic-warning" />}
          <p>{description}</p>
        </section>
        <section className="modal-actions">
          {customFooter || (
            <>
              {reverse ? (
                <>
                  {onCancel && <span onClick={onCancel}>{cancelText}</span>}
                  {onRetry && <span onClick={onRetry}>{retryText}</span>}
                </>
              ) : (
                <>
                  {onRetry && <span onClick={onRetry}>{retryText}</span>}
                  {onCancel && <span onClick={onCancel}>{cancelText}</span>}
                </>
              )}
            </>
          )}
        </section>
      </div>
    </div>
  );
};

export default FailModal;
